import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { Polyline } from 'react-naver-maps';
import { tooltipAtom } from '.';
import React, { useEffect, useState } from 'react';
import {
  backdropAtom,
  changeCarListAtom,
  mapZoomLevelAtom,
  MARKER_VIEW_ZOOM,
  polyLineOverAtom,
  shippingCardOverAtom,
} from '@/commons/constants';
import { Dest, TimeLine } from '@/types/result';

export default function RoutingLine({ list }: { list: TimeLine[] }) {
  const setTooltip = useSetAtom(tooltipAtom);
  const setBackdrop = useSetAtom(backdropAtom);
  const [polyLineOver, setPolyLineOver] = useAtom(polyLineOverAtom);

  const mapZoomLevel = useAtomValue(mapZoomLevelAtom);

  const shippingCardOver = useAtomValue(shippingCardOverAtom);

  const [highlightList, setHilightList] = useState<number[]>([]);

  const [lineList, setLineList] = useState([]);

  const changeCarList = useAtomValue(changeCarListAtom);

  useEffect(() => {
    let ret: any[] = [];
    if (list) {
      ret = list.map((item: TimeLine, cIndex: number) => {
        const check = highlightList.length > 0 && highlightList.findIndex((fItem) => fItem === item.car.car_seq) > -1;
        const routeArray = [];
        let arrowMode = false;
        if (
          (list.length < 4 && mapZoomLevel > MARKER_VIEW_ZOOM + 2) ||
          (mapZoomLevel > MARKER_VIEW_ZOOM + 2 && check)
        ) {
          arrowMode = true;
        }

        if (arrowMode) {
          for (let i = 1; i < item.route.length; i += 5) {
            routeArray.push(item.route.slice(i - 1, i + 5));
          }
        } else {
          routeArray.push(item.route);
        }

        setBackdrop(false);
        return {
          target: item,
          check,
          destList: item.destList,
          routeArray,
          reverse: item.reverse,
        };
      });
    }
    setLineList(ret);
  }, [list, mapZoomLevel, highlightList]);

  useEffect(() => {
    //활성화(highlight) 대상 선정
    const temp: number[] = [];
    polyLineOver && temp.push(polyLineOver); //경로에 마우스 오버

    shippingCardOver && temp.push(shippingCardOver); //목록 마우스 오버
    setHilightList(temp);
  }, [polyLineOver, shippingCardOver]);

  const handleMouseOver = (item: any) => {
    setTooltip({ type: 'route', ...item });
    setPolyLineOver(item.carId);
  };

  const handleMouseOut = () => {
    setTooltip(undefined);
    setPolyLineOver(undefined);
  };

  return (
    <>
      {lineList.length > 0 &&
        lineList.map((item: any, index: number) => {
          let target = item;
          let modMode = false;
          if (
            changeCarList.length > 0 &&
            changeCarList.findIndex((fItem: number) => fItem === item.target.car.car_seq) > -1
          ) {
            const tempRoute = [
              { lat: item.target.car.start_info.lat, lng: item.target.car.start_info.lng },
              ...item.destList.map((tItem: Dest) => tItem.coord),
            ].filter((v) => v);
            item.reverse.length > 0 && tempRoute.push(item.reverse[item.reverse.length - 1]);
            target = {
              ...item,
              reverse: [],
              routeArray: [tempRoute],
            };
            modMode = true;
          }

          return (
            <React.Fragment key={index}>
              {target.routeArray.map((rItem: any, rIndex: number) => (
                // return (
                <Polyline
                  key={index + '_' + rIndex}
                  path={rItem}
                  strokeStyle={modMode === true ? 'shortdash' : 'solid'}
                  strokeWeight={target.check ? 7 : 5}
                  strokeColor={target.target.color}
                  strokeOpacity={highlightList.length == 0 || target.check ? 1 : 0.4}
                  zIndex={target.check ? index + list.length : index}
                  endIcon={naver.maps.PointingIcon.OPEN_ARROW}
                  endIconSize={target.check ? 15 : 11}
                  onMouseover={() => handleMouseOver(target.target)}
                  onMouseout={handleMouseOut}
                  clickable
                />
                // );
              ))}
              <Polyline
                key={'R_' + index}
                path={target.reverse}
                strokeWeight={target.check ? 7 : 5}
                strokeColor="#777777"
                strokeStyle="shortdash"
                strokeOpacity={highlightList.length == 0 || target.check ? 1 : 0.4}
                zIndex={(target.check ? index + list.length : index) + 1}
                onMouseover={() => handleMouseOver(target.target)}
                onMouseout={handleMouseOut}
                clickable
              />
            </React.Fragment>
          );
        })}
    </>
  );
}
